import lazyLoading from "./lazyLoading";

export default {
  name: "Finances",
  meta: {
    icon: "fa-book",
    expanded: false,
    permissions: "access finances",
    external: false
  },

  children: [
    {
      name: "finances",
      path: "/admin/finances",
      meta: {
        title: "Finances",
        label: "Liste",
        //isAdminStaff: true,
        permissions: "access finances",
        external: false
      },
      component: lazyLoading("finances", true)
    },
    {
      name: "status-finances",
      path: "/admin/finance/statuts",
      meta: {
        title: "Liste des statuts",
        label: "Statuts",
        permissions: "access finances",
        external: false
      },
      component: lazyLoading("finances/Status")
    },
    {
      name: "tasks-types",
      path: "/admin/finance/task_types",
      meta: {
        title: "Liste des tâches",
        label: "Tâches",
        permissions: "add task types",
        external: false
      },
      component: lazyLoading("finances/TaskTypes")
    },
    {
      name: "import-credits",
      path: "/admin/credits/import",
      meta: {
        title: "Attribution de réductions",
        label: "Réductions",
        permissions: "bulk credit",
        external: false
      },
      component: lazyLoading("finances/credits/ImportCredits")
    },
    {
      name: "import-promo",
      path: "/admin/promo/import",
      meta: {
        title: "Attribution de codes bourse",
        label: "Codes bourse",
        permissions: "bulk promo",
        external: false
      },
      component: lazyLoading("finances/credits/ImportPromoCode")
    },
  ]
};
